import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import white from '../img/Generale/white.jpg';
import { Link } from 'react-router-dom';

const Contattis = () => {

    return (
        <div>
            <Container fluid>
                <Row>
                    <Col className=" ProgettiColonnaContatti" >
                        <div data-aos="fade">

<div>
                        <div className="responsive">
                            <div className="gallery">
                                <div className="content">
                                    <div className="content-overlay"></div>

                                    <a href="mailto:acalasanzio@outlook.com" className="content-link">
                                        <img src={white} width="80%" height="280px" alt="Mail Icon" />
                                        <div className="content-details fadeIn-bottom">
                                            <h3 className="content-title buttone">MAIL</h3>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>





                        <div className="responsive">
                            <div className="gallery">
                                <div className="content">
                                    <div className="content-overlay"></div>

                                    <a href="https://www.linkedin.com/in/alessandro-calasanzio/" target="_blank" rel="noreferrer" className="content-link">
                                        <img src={white} width="80%" height="280px" alt="LinkedIn Icon" />
                                        <div className="content-details fadeIn-bottom">
                                            <h3 className="content-title buttone">LINKEDIN</h3>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>






                        <div className="responsive">
                            <div className="gallery">
                                <div className="content">
                                    <div className="content-overlay"></div>
                                    <a href="https://www.instagram.com/vlecvi/" target="_blank" rel="noreferrer" className="content-link">
                                        <img src={white} width="80%" height="280px" alt="LinkedIn Icon" />
                                        <div className="content-details fadeIn-bottom">
                                            <h3 className="content-title buttone">IG</h3>
                                        </div>
                                    </a>
                                   
                                </div>
                            </div>
                        </div>

                        </div>

                        </div>


                    </Col>

                    <Col id="ColHover" className=' thumbContatti colRight ' md={2}>
                       <div data-aos="fade">
                        <Link to="/contatti">
                            <h1 className='vertical-rl1 '><small className='more'>More to</small> Contatti</h1>
                        </Link>
                        </div>
                    </Col>
                </Row>

            </Container>



        </div>

    );
}

export default Contattis;